// const CurrencyFormatter = (amount) => {
//   return new Intl.NumberFormat("en-NG", {
//     style: "currency",
//     currency: "NGN",
//     currencyDisplay: "symbol",
//     minimumFractionDigits: 2,
//   }).format(amount);
// };

// export default CurrencyFormatter;

const CurrencyFormatter = (amount) => {
  // Remove commas and parse to float
  const numericAmount = parseFloat((amount || "0").toString().replace(/,/g, ""));

  if (isNaN(numericAmount)) return "₦0.00";

  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  }).format(numericAmount);
};

export default CurrencyFormatter;
